import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Spinner from "./../Assets/Images/spinner.gif";
import "./JobDetails.css";
import JobInfoItem from "../components/Common/Icon/JobInfoItem";
import Header from "../components/Header";
import { CompanyContext } from "../contexts/CompanyContext";
import { useNavigate } from "react-router-dom";
import UploadResume from "./UploadResume";
import toast, { Toaster } from "react-hot-toast";
const JobDetails = () => {
  const { companyLogo, headerColor, fontFamily, primaryColor, secondaryColor } =
    useContext(CompanyContext);
  const { jobId } = useParams();
  const [jobDetails, setJobDetails] = useState(null);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleGoBack = () => {
    navigate("/");
  };

  useEffect(() => {
    setLoader(true);
    axios
      .post(`https://hrms-api.apisod.ai/api/job-list`)
      .then((res) => {
        const jobs = res.data.data;
        const matchedJob = jobs.find((job) => String(job.job_id) == jobId);
        setJobDetails(matchedJob);
        setLoader(false);
      })
      .catch((error) => {
        console.error("Error fetching job details:", error);
        setLoader(false);
      });
  }, [jobId]);
  console.log({ jobDetails });
  const extractTextFromHTML = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent;
  };
  return (
    <>
      <Header logo={companyLogo} headerColor={headerColor} />
      <div
        className="inner-banner"
        style={{
          fontFamily,
          "--mainColor": primaryColor,
          "--titleColor": secondaryColor,
        }}
      >
        <div className="container">
          <div className="inner-title text-center">
            <h3>Job Details</h3>
            <ul>
              <li>
                <a onClick={handleGoBack} style={{ cursor: "pointer" }}>
                  Home
                </a>
              </li>
              <li>Job Details</li>
            </ul>
          </div>
        </div>
      </div>
      <div
        className="job-details-area pt-100 pb-70"
        style={{
          fontFamily,
          "--mainColor": primaryColor,
          "--titleColor": secondaryColor,
        }}
      >
        {loader ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: "100vh",
              transition: "opacity 0.5s",
              opacity: loader ? 1 : 0,
            }}
          >
            <img src={Spinner} alt="Loading..." />
          </div>
        ) : (
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="find-jobs-card d-flex align-items-center box-shadow">
                  <div className="content">
                    <ul className="content-list">
                      <li className={`item-1`}>{jobDetails?.job_type}</li>
                      <li className={`item-2`}>{jobDetails?.work_model}</li>
                      <li className={`item-3`}>{jobDetails?.shift_timing}</li>
                    </ul>
                    <h3>
                      <a href="#">
                        {jobDetails?.job_title} ({jobDetails?.job_id})
                      </a>
                    </h3>
                    <ul className="content-list2">
                      <li className="list-two">
                        <i className="ri-book-2-line"></i>
                        {jobDetails?.skills_required.join(", ")}
                      </li>
                      <li className="list-two">
                        <i className="ri-time-line"></i>{" "}
                        {jobDetails?.job_posting_date}
                      </li>
                    </ul>
                    <ul className="content-list3">
                      <JobInfoItem
                        icon="ri-briefcase-line"
                        label="Category"
                        value={jobDetails?.job_function.name}
                      />
                      <JobInfoItem
                        icon="ri-map-pin-line"
                        label="Location"
                        value={jobDetails?.location}
                      />
                      <JobInfoItem
                        icon="ri-currency-line"
                        label="Salary"
                        value={jobDetails?.salary_range}
                      />
                    </ul>
                  </div>

                  <div className="find-jobs-btn">
                    <a
                      className="default-btn border-radius-5"
                      onClick={handleShowModal}
                    >
                      Apply Now<i className="ri-send-plane-2-line"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="job-details-widget-side pr-20">
                  <div className="job-details-widget">
                    <h3 className="title">Job Overview</h3>
                    <div className="bar"></div>
                    <ul className="job-details-category">
                      <li>
                        Published On:{" "}
                        <span>{jobDetails?.job_posting_date}</span>
                      </li>
                      <li>
                        Job Type: <span>{jobDetails?.job_type}</span>
                      </li>
                      <li>
                        Experience:{" "}
                        <span>{jobDetails?.experience_required} Year(s)</span>
                      </li>
                      <li>
                        Job Location: <span>{jobDetails?.location}</span>
                      </li>
                      <li>
                        Category:{" "}
                        <span>
                          {jobDetails?.job_function?.name || "Not Specified"}
                        </span>
                      </li>
                      <li>
                        Travel Required:{" "}
                        <span>{jobDetails?.travel_required}</span>
                      </li>
                      <li>
                        Application Due:{" "}
                        <span>{jobDetails?.application_deadline}</span>
                      </li>
                    </ul>

                    <div className="job-details-social">
                      <span>Share Post:</span>
                      <ul className="social-icon">
                        <li>
                          <a href="https://www.facebook.com/" target="_blank">
                            <i className="ri-facebook-fill"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/" target="_blank">
                            <i className="ri-instagram-fill"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://twitter.com/" target="_blank">
                            <i className="ri-twitter-fill"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/" target="_blank">
                            <i className="ri-linkedin-fill"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="job-details-widget">
                    <h3 className="title">Job Skills</h3>
                    <div className="bar"></div>
                    <ul className="job-details-widget-tag">
                      {jobDetails?.skills_required?.map((item) => {
                        return (
                          <li key={item}>
                            <a href="#">{item}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-8">
                <div className="job-details-content">
                  <div className="content mb-30">
                    <h3>Job Description</h3>
                    <div className="bar"></div>
                    {extractTextFromHTML(jobDetails?.job_description)}
                  </div>

                  <h3>How to Apply</h3>
                  <div className="bar"></div>
                  {extractTextFromHTML(jobDetails?.how_to_apply)}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Modal for UploadResume */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Applying for - {`${jobDetails?.job_title} (${jobDetails?.job_id})`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadResume
            onSuccess={handleCloseModal}
            jobId={jobDetails?.job_id}
          />
        </Modal.Body>
      </Modal>
      <Toaster />
    </>
  );
};

export default JobDetails;
